import React, { useState } from 'react';
import {
    DatabaseId, VerificationForm,
} from '@sheerid/jslib';
import { getQueryParamsByName } from '../../lib/utils/browser';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';


interface SocialSharingLandingPageProps {
    programId: DatabaseId;
    trackingId?: string;
    logoUrl?: string;
    intl?: any;
}

const SocialSharingLandingPage = ({ programId, trackingId, logoUrl, intl }: SocialSharingLandingPageProps) => {
    const shareUrl = getQueryParamsByName('shareUrl') || '';
    const [buttonWiggle, setButtonWiggle] = useState(shareUrl ? true : false);
    const [showButtonResult, setShowButtonResult] = useState(false);

    let shareResult = intl.formatMessage({ id: "socialSharing.copyToClipboard", defaultMessage: 'Offer URL copied to clipboard' });
    const shareData = {
        title: intl.formatMessage({ id: "socialSharing.title", defaultMessage: 'Calling all students...' }),
        text: intl.formatMessage({ id: "socialSharing.subtitle", defaultMessage: 'Style like you mean it with 20% OFF' }),
        url: shareUrl || `${window.location.origin}${window.location.pathname}?layout=landing`,
    }

    if (buttonWiggle) {
        setTimeout(() => { setButtonWiggle(false); }, 3000);
    }

    const handleOnClick = async () => {
        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (err) {
                shareResult = intl.formatMessage({ id: "socialSharing.shareError", defaultMessage: `Error while trying to share: ${err}` }, {err: err});
            };
        } else {
            try {
                await navigator.clipboard.writeText(shareData.url);
                setShowButtonResult(true);
                setTimeout(() => { setShowButtonResult(false) }, 6000);
            } catch(err) {
                shareResult = intl.formatMessage({ id: "socialSharing.copyToClipboardError", defaultMessage: `Error copying to clipboard: ${err}` }, {err: err});
            }
        }
    }

    return (
        <div id="landing-main-container" className="offer__container">
            <div className="offer__top-content">
                <div className="offer-wrapper">
                    <div className="offer__side-content">
                        { logoUrl ?
                            <img className="offer__logo" alt="offer company logo" src={`${logoUrl}`} />
                        : null }
                        <h1 className="page-title">
                            <FormattedHTMLMessage
                                id="socialSharing.title"
                                defaultMessage="Calling all students..."
                            />
                        </h1>
                        <span className="page-description">
                            <FormattedHTMLMessage
                                id="socialSharing.subtitle"
                                defaultMessage="Style like you mean it with 20% OFF"
                            />
                        </span>

                        <div className="offer-share">
                            <button
                                className={`offer-share__btn ${buttonWiggle ? 'offer-share__btn--wiggle' : ''}`}
                                onClick={() => handleOnClick()}
                            >
                                    <FormattedHTMLMessage
                                        id="socialSharing.buttonText"
                                        defaultMessage="Tell a friend"
                                    />
                            </button>
                            <div className="offer-share__result">
                                <div className={`offer-share__result-text ${showButtonResult ? 'offer-share__result-text--active' : ''}`}>
                                    <FormattedHTMLMessage
                                        id="socialSharing.copyToClipboard"
                                        defaultMessage="Offer URL copied to clipboard"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <VerificationForm programId={programId} trackingId={trackingId}/>
                </div>
            </div>
            <div className="offer__bottom-content">
                <div className="offer-wrapper">
                    <div className="offer__description">
                        <p>
                        <FormattedHTMLMessage
                            id="socialSharing.instructions.title"
                            defaultMessage="To get the discount:"
                        />
                        </p>
                        <p>
                            <FormattedHTMLMessage
                                id="socialSharing.instructions.part1"
                                defaultMessage="1. Verify your student status with SheerID by filling in the above verification form. Offer available to students enrolled in educational classes for which you can earn credit towards a diploma, degree or professional license."
                            />
                        </p>
                        <p>
                            <FormattedHTMLMessage
                                id="socialSharing.instructions.part2"
                                defaultMessage="2. After successful verification, you\'ll receive a single-use promo code"
                            />
                        </p>
                        <p>
                            <FormattedHTMLMessage
                                id="socialSharing.instructions.part3"
                                defaultMessage="3. Use the promo code during checkout to redeem the offer"
                            />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const SocialSharingLandingPageComponent = injectIntl(SocialSharingLandingPage);
